import { render, staticRenderFns } from "./EbkVedom.vue?vue&type=template&id=40a72c65&"
import script from "./EbkVedom.vue?vue&type=script&lang=js&"
export * from "./EbkVedom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports